// IMPORTAÇÃO DAS BIBLIOTECAS----------------------------------------------------------------------
import { useState, useEffect, useRef } from 'react';
import { useOutletContext } from 'react-router-dom';
// import { SlNote } from "react-icons/sl";
import { toast, ToastContainer } from 'react-toastify';
import { ClipLoader } from "react-spinners"; // Icone de Carregamento spinner
import 'react-toastify/dist/ReactToastify.css';
import { TbHandMove } from "react-icons/tb";
import { useTranslation } from 'react-i18next';



// IMPORTAÇÃO DOS COMPONENTES----------------------------------------------------------------------
import { api } from '../../services/api.js';
import { addListener, removeListener } from '../../services/eventBus.js';
import styles from './notepad.module.css';
import Nav from './components/nav.js';
import NewNote from "./components/newNote.js";
import Notes from './components/notas.js'
import Trash from './components/trash.js';
import ConfirmModal from '../../components/modalConfirm/ConfirmModal.js';
import AlertModal from '../../components/alertModal/alertModal.js';
import WelcomePanel from './components/welcomePanel.js';
import NewsPanel from './components/newsPanel.js';
import { useAppContext } from "../../AppContext.js";
import ComponentLoad from "../../components/componentLoad/componentLoad.js";
import ExpiredPlanPanel from './components/expiredPlanPanel.js';
import InfoAnimation from '../../components/infoAnimation/infoAnimation.js' // componente para exibir mensagens de sucesso
import InfoAnimationErro from '../../components/infoAnimation/infoAnimationErro.js' // componente para exibir mensagens de erro
import VisualNote from './components/visualNote.js'; // modal para visualização da nota em tamanho maior



const BlocoNotas = () => {
  const { searchTerm } = useOutletContext(); // usado pela caixa de pesquisa da barra superior

  // CONSTANTES E VARIÁVEIS------------------------------------------------------------------------
  const [error, setError] = useState(null); // Estado para armazenar o erro em caso de sessão expirada
  const [loading, setLoading] = useState(true); // Estado para controlar o carregamento inicial
  const [allNotes, setAllNotes] = useState([]); // Estado para buscar todas as notas
  const [trashNotes, setTrashNotes] = useState([]); // Estado para buscar notas excluídas
  const [NewNoteOpen, setNewNoteOpen] = useState(false); // Estado para controlar a abertura do formulário de nova nota
  const [trashOpen, setTrashOpen] = useState(false); // estado para controlar abertura da lixeira
  const [loadingTrash, setLoadingTrash] = useState(false); // estado para controlar load dentro do componente lixeira
  const [processingNoteId, setProcessingNoteId] = useState(null); // estado para mostrar icono loading nas notas da lixeira
  const [dragActive, setDragActive] = useState(false); // Estado para ativar painel de mininotas para organizar
  const [dragOn, setDragOn] = useState(true) // ativa e desativa o drag no painel de mininotas para load
  const [dragLoading, setDragLoading] = useState('') // ativar icone loading para aguardar gravar o drag das mininotas
  const [draggedIndex, setDraggedIndex] = useState(null); // Estado para controlar o índice da nota sendo arrastada
  const [dragOverIndex, setDragOverIndex] = useState(null); // Estado para controlar o índice da nota onde o drop está ocorrendo
  const [filter, setFilter] = useState(() => localStorage.getItem("notepadFilter") || "all"); // Estado para filtro
  const [confirmModal, setConfirmModal] = useState({ // estado para controlar a abertura do modal de confirmação
    isOpen: false,
    title: "",
    message: "",
    onConfirm: null,
    onCancel: null,
  });
  const [editingNote, setEditingNote] = useState(null); // Estado para a nota sendo editada no modal
  const [visualNoteOpen, setVisualNoteOpen] = useState(false); // Estado para controlar abertura da nota em visualização cheia
  const [visualNoteData, setVisualNoteData] = useState(null); // Dados da nota em visualização cheia
  const [alertModal, setAlertModal] = useState({// estado para controlar abertura do modal de alerta
    isOpen: false,
    title: "",
    message: "",
    onConfirm: null,
  });
  const [showWelcome, setShowWelcome] = useState(false); // estado para controlar abertura do modal de boas-vindas
  const [newsOpen, setNewsOpen] = useState(false); // estado para controlar abertura do painel de dicas de uso
  const [showExpiredPlan, setShowExpiredPlan] = useState(false); // estado para controlar abertura do modal de plano expirado
  const [fontSize, setFontSize] = useState(() => Number(localStorage.getItem("notepadFontSize")) || 12); //tamanho da fonte da nota
  // const [fontType, setFontType] = useState(() => localStorage.getItem("notepadFontType") || "A"); // tipo da fonte da nota
  const [visualNotes, setVisualNotes] = useState(() => localStorage.getItem("tipoVisualizacao") || "notaDupla"); // modo de visualização
  const isEditingRef = useRef(false); // define se usuário está editando alguma nota (evita atualização automática via ws)
  const wsSendRef = useRef(false); // impede WebSocket de processar a própria ação (evita duplicidade)
  const timeOffRef = useRef(new Date()); // timet para atualizar todas as notas caso tempo sem visualização da página
  const { t } = useTranslation(); // hook de tradução
  const { isApp } = useAppContext(); // define se está sendo acessado pelo app ou pelo site

  // mensagens de sucesso ao realizar ações
  const [showSuccess, setShowSuccess] = useState(false); //abre caixa do sucesso
  const [showSuccessMsg, setShowSuccessMsg] = useState(''); // mensagem de sucesso
  const [showSuccessDuration, setShowSuccessDuration] = useState(0);

  // Estados e handlers para animação de erro
  const [showErro, setShowErro] = useState(false);
  const [showErroMsg, setShowErroMsg] = useState('');
  const [showErroDuration, setShowErroDuration] = useState(0);

  // teclado virtual
  const [isKeyboardVisible, setIsKeyboardVisible] = useState(false); // Indica se o teclado virtual está aberto

  // Listener para transcrição por microfone (disparo pelo Nav)
  useEffect(() => {
    async function handleTranscript(e) {
      const transcript = e.detail || '';
      if (!transcript) return;
      const titleTranscrit = t('Audio transcribed');
      try {
        // simular erro para debug
        //throw new Error("Simulated error");

        // Cria a nota automaticamente com título 'gravado'
        await handleSubmit(
          titleTranscrit,
          transcript,
          null,
          'colorBlack',
          'bgWrite',
          '',
          '',
          'estiloTextoA',
          false
        );
        // showSuccess é definido dentro de handleSubmit
      } catch (err) {
        console.error('Error creating note from transcript:', err);
        // toast.error(t('Error creating note from transcription'));
        setShowErroMsg(t('Error creating note from transcription'));
        setShowErroDuration(2500); setShowErro(true); setLoading(false);
      } finally {
        window.dispatchEvent(new CustomEvent('speech-transcript-end'));
      }
    }

    // Listener para erros de transcrição por microfone
    function handleSpeechError(e) {
      //const msg = e.detail || t('Speech recognition not supported');
      console.log(e.detail)
      const msg = t('Allow the app access to your microphone to use voice transcription.') // mensagem mais genérica para cobrir casos de permissão negada ou erro de reconhecimento;
      // toast.error(msg);
      setShowErroMsg(msg);
      setShowErroDuration(5000); setShowErro(true); setLoading(false);
    }

    window.addEventListener('speech-transcript', handleTranscript);
    window.addEventListener('speech-error', handleSpeechError);
    return () => {
      window.removeEventListener('speech-transcript', handleTranscript);
      window.removeEventListener('speech-error', handleSpeechError);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);



  // GRAVAR ÚLTIMO ACESSO DO USUÁRIO AO SISTEMA----------------------------------------------------
  // hook para gravar data do último acesso do usuário ao sistema
  function registerLastAccess() {
    try {
      const viaAcesso = localStorage.getItem('viaAcesso') === 'app' ? 'app' : 'web';
      api.post('/auth/user/lastAccess', {
        app: "tsnotes",
        viaAcesso: viaAcesso
      });
      // console.log("Último acesso registrado com sucesso!"); // somente em desenvolvimento
    } catch (error) {
      console.error("Erro ao registrar último acesso:", error);
    }
  }
  // esta funcção também é utilizada em caso de atualização após página em segundo plano
  useEffect(() => {
    registerLastAccess()
  }, []);



  // VERIFICAR PRIMEIRO ACESSO E MOSTRAR WELCOME PANEL OU NEWS PANEL ----------------------------------------------
  useEffect(() => {
    const firstAccess = localStorage.getItem('firstAccess');
    // Se não existir 'firstAccess' ou se for true, significa que é o primeiro acesso
    if (firstAccess === null || firstAccess === 'true') {
      setShowWelcome(true);
    } else {
      if (localStorage.getItem('news') === null || localStorage.getItem('news') === 'true') {
        setNewsOpen(true);
      }
    }
  }, []);



  // SERVIÇOS WEBSOCKET----------------------------------------------------------------------------
  // funcção para definir status de edição de notas (evita atualização automática via ws)
  function isEditingChange(status) {
    isEditingRef.current = status
  };

  // mensagens websocket
  useEffect(() => {
    const handleMessage = ({ event: tipo, data }) => {
      try {
        if (wsSendRef.current) {
          wsSendRef.current = false;
          return;
        }
        if (isEditingRef.current) {
          return;
        }

        if (!data || !data._id) return; // proteção extra

        switch (tipo) {
          case 'note-updated':
          case 'note-trash':
          case 'note-archive':
          case 'note-priority':
            setAllNotes(prev => prev.map(n => n._id === data._id ? { ...n, ...data } : n));
            break;
          case 'note-create':
            setAllNotes(prevNotes => [...prevNotes, data]);
            break;
          default:
            console.warn('Unknown WebSocket event type:', tipo);
        }
      } catch (error) {
        console.error('Error processing WebSocket message:', error);
      }
    };

    addListener(handleMessage);
    return () => removeListener(handleMessage);
  }, []);



  // RECARREGA NOTAS CASO PERÍODO SEM PÁGINA VISIVEL-----------------------------------------------
  useEffect(() => {
    async function getAllNotes() {
      window.dispatchEvent(new CustomEvent('app-syncing', { detail: "true" }));
      try {
        const response = await api.get('/annotations/read');
        // console.log("anotações carregadas com sucesso!"); // somente em desenvolvimento
        registerLastAccess();
        if (!isEditingRef.current) {
          setAllNotes(response.data.annotationList);
        }
        setError(null);
      } catch (err) {
        setError(err);
        window.dispatchEvent(new CustomEvent('app-syncing', { detail: "erro" }));
        console.error(err.response?.data?.msg || err.message);
        // toast.error("Erro ao carregar anotações");
      } finally {
        setTimeout(() => {
          window.dispatchEvent(new CustomEvent('app-syncing', { detail: "false" }));
        }, 1000);
      }
    }

    function handleVisibilityChange() {
      if (document.visibilityState === 'visible') {
        const timeNow = new Date();
        const timeOffInMs = 60 * 1000; // 1 minuto

        if (!isEditingRef.current && (timeNow - timeOffRef.current > timeOffInMs)) {
          getAllNotes();
        }

      } else {
        timeOffRef.current = new Date()
        // console.log(timeOffRef.current) // somente em desenvolvimento
      }
    }

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);



  // FUNÇÕES UTILITÁRIAS DO MÓDULO-----------------------------------------------------------------
  // hook para avisar sessão expirada caso erro 401 (token expirado)
  useEffect(() => {
    if (
      error &&
      error.response?.status === 401
    ) {
      setAlertModal({
        isOpen: true,
        title: t("Session expired"),
        message: t("Your session has expired. Please log in again."),
        onConfirm: () => {
          localStorage.removeItem('contConectado');
          setAlertModal({ isOpen: false });
          window.location.href = '/';
        },
      });
    }
  }, [error, t]);

  // Gerencia efeitos colaterais do painel de mover notas (scroll lock, fechar com ESC).
  useEffect(() => {
    if (!dragActive) return;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const handleEsc = (e) => {
      if (e.key === "Escape") setDragActive(false);
    };
    window.addEventListener("keydown", handleEsc);
    return () => {
      document.body.style.overflow = previousOverflow || "";
      window.removeEventListener("keydown", handleEsc);
    };
  }, [dragActive]);

  // Função para alterar o tamanho da fonte
  function handleFontSizeChange(newSize) {
    setFontSize(newSize);
    localStorage.setItem("notepadFontSize", newSize);
  }

  // Função para alterar o tipo da fonte
  // function handleFontTypeChange(newFontType) {
  //   setFontType(newFontType);
  //   localStorage.setItem("notepadFontType", newFontType);
  // }

  // Função para alterar o modo de visualização
  function handleVisualNotesChange(newVisual) {
    setVisualNotes(newVisual);
    localStorage.setItem("tipoVisualizacao", newVisual);
  }

  // Listener para ocultar o menu caso teclado virtual aberto
  useEffect(() => {
    const handleViewportChange = () => {
      if (window.visualViewport) {
        // Verifica se o teclado virtual está aberto (viewport menor que 75% da tela).
        // Isso é muito útil para o WebView (isApp) ocultar o painel quando o teclado for fechado.
        const isKeyboardOpen = window.visualViewport.height < window.screen.height * 0.75;
        setIsKeyboardVisible(isKeyboardOpen);
      }
    };

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', handleViewportChange);
      handleViewportChange(); // Chamada inicial

      return () => {
        window.visualViewport.removeEventListener('resize', handleViewportChange);
      };
    }
  }, []);



  // FUNÇÕES PARA MANIPULAR AS ANOTAÇÕES-----------------------------------------------------------
  // função para abrir o modal de edição de nota
  function openEditNote(note) {
    setEditingNote(note);
    setNewNoteOpen(true);
  }

  // função para abrir o modal de visualização de nota
  function openVisualNote(note) {
    setVisualNoteData(note);
    setVisualNoteOpen(true);
  }

  //hook para buscar todas as anotações ao carregar a página
  useEffect(() => {
    async function getAllNotes() {
      setLoading(true);
      try {
        const response = await api.get('/annotations/read');
        // console.log("anotações carregadas com sucesso!") // somente em desenvolvimento
        setAllNotes(response.data.annotationList);

        // verifica se usuário tem plano ativo e avisa caso plano expirado
        if (!response.data.isActivatedUser) {
          setShowExpiredPlan(true);
        }

        setError(null); // Limpa o erro se sucesso
      } catch (err) {
        setError(err); // Salva o erro
        console.error(err.response.data.msg, err);
        toast.error(t("Error loading notes. Try again later!"));
      } finally {
        setLoading(false)
      }
    }
    getAllNotes();

    // desabilita aviso de dependências
    // eslint-disable-next-line
  }, []);

  // função para adicionar uma nova anotação
  async function handleSubmit(title, notes, listContent, colorFont, background, fontWeight, italicFont, font, priority) {
    try {
      wsSendRef.current = true; // impede WebSocket de processar a própria ação (evita duplicidade)
      const response = await api.post('/annotations/create', {
        title,
        notes,
        listContent,
        colorFont,
        background,
        fontWeight,
        italicFont,
        font,
        priority
      });
      setAllNotes(prevNotes => [...prevNotes, response.data]);

      // mensagem de sucesso ao salvar anotação
      setShowSuccessDuration(2000);
      setShowSuccessMsg(t("Note created successfully!"))
      setShowSuccess(true);

      //toast.success(t("Note created successfully!"));
      return Promise.resolve(); // sucesso
    } catch (error) {
      return Promise.reject(error); // erro
    }
  }

  // função para salvar uma anotação editada
  async function handleSaveEdit(id, date, updatedNotes, listContent) {
    wsSendRef.current = true; // impede WebSocket de processar a própria ação (evita duplicidade)
    try {
      const response = await api.post(`/annotations/update/${id}`, {
        notes: updatedNotes,
        date: date,
        listContent: listContent
      });

      if (response.status === 409) {
        return Promise.reject(response.data.message); // conflito de edição
      }

      setAllNotes(prevNotes =>
        prevNotes.map(note =>
          note._id === id ? response.data : note
        )
      );

      // atualiza a anotação no visualNoteOpen se estiver aberta
      if (visualNoteOpen && visualNoteData._id === id) {
        setVisualNoteData(response.data);
      }

      return Promise.resolve(); // sucesso
    } catch (error) {
      return Promise.reject(error); // erro
    }
  }

  // função para salvar uma anotação com todos os seus parâmetros no modal
  async function handleSaveFullEdit(title, notes, listContent, colorFont, background, fontWeight, italicFont, font, priority) {
    if (!editingNote) return Promise.reject("No note to edit");
    wsSendRef.current = true; // impede WebSocket de processar a própria ação (evita duplicidade)
    try {
      const response = await api.post(`/annotations/update/${editingNote._id}`, {
        title,
        notes,
        listContent,
        colorFont,
        background,
        fontWeight,
        italicFont,
        font,
        priority,
        date: editingNote.date // passa a data atual da nota para validar conflitos
      });

      if (response.status === 409) {
        return Promise.reject(response.data.message); // conflito de edição
      }

      setAllNotes(prevNotes =>
        prevNotes.map(note =>
          note._id === editingNote._id ? response.data : note
        )
      );

      // mensagem de sucesso ao editar anotação
      setShowSuccessDuration(2000);
      setShowSuccessMsg(t("Note updated successfully!"))
      setShowSuccess(true);
      setEditingNote(null);

      return Promise.resolve(); // sucesso
    } catch (error) {
      return Promise.reject(error); // erro
    }
  }

  // função para mover ou restaurar uma anotação para a lixeira
  async function handleTrash(id, date) {
    wsSendRef.current = true; // impede WebSocket de processar a própria ação (evita duplicidade)
    try {
      const response = await api.post(`/annotations/trash/${id}`, {
        date: date
      });

      if (response.status === 409) {
        return Promise.reject(response.data.message); // conflito de edição
      }

      setAllNotes(prevNotes => {
        const updatedNotes = prevNotes.filter(note => note._id !== id);
        return [...updatedNotes, { ...response.data }];
      });

      // atualiza a anotação no visualNoteOpen se estiver aberta
      if (visualNoteOpen && visualNoteData._id === id) {
        setVisualNoteData(response.data);
        setVisualNoteOpen(false);
      }

      return Promise.resolve(); // sucesso
    } catch (error) {
      const note = allNotes.find(n => n._id === id);
      if (note.trash) { toast.error(t("Error restoring note!")); } // mensagem toast apenas em caso de erro de restauração na lixeira
      console.error('Error sending annotation to trash:', error);
      return Promise.reject(error); // erro
    }
  }

  // função para mover ou restaurar uma anotação do arquivo
  async function handleArchive(id, date) {
    wsSendRef.current = true; // impede WebSocket de processar a própria ação (evita duplicidade)
    try {
      const response = await api.post(`/annotations/archive/${id}`, {
        date: date
      });

      if (response.status === 409) {
        return Promise.reject(response.data.message); // conflito de edição
      }

      setAllNotes(prevNotes => {
        const updatedNotes = prevNotes.filter(note => note._id !== id);
        return [...updatedNotes, { ...response.data }];
      });

      // atualiza a anotação no visualNoteOpen se estiver aberta
      if (visualNoteOpen && visualNoteData._id === id) {
        setVisualNoteData(response.data);
        setVisualNoteOpen(false);
      }

      return Promise.resolve(); // sucesso
    } catch (error) {
      console.error('Error archiving or unarchiving:', error);
      return Promise.reject(error); // erro
    }
  }

  // função para alterar prioridade da anotação
  async function handleTogglePriority(id, date) {
    wsSendRef.current = true; // impede WebSocket de processar a própria ação (evita duplicidade)
    try {
      const response = await api.post(`/annotations/priority/${id}`, {
        date: date
      });

      if (response.status === 409) {
        return Promise.reject(response.data.message); // conflito de edição
      }

      setAllNotes(prevNotes =>
        prevNotes.map(note =>
          note._id === id ? { ...note, ...response.data } : note
        )
      );

      // atualiza a anotação no visualNoteOpen se estiver aberta
      if (visualNoteOpen && visualNoteData._id === id) {
        setVisualNoteData(response.data);
      }

      return Promise.resolve(); // sucesso
    } catch (error) {
      console.error('Error changing priority:', error);
      return Promise.reject(error); // erro
    }
  }

  // função para atualizar o conteúdo da nota editada em outro dispositivo
  async function handleRefresh(id) {
    try {
      const response = await api.get(`/annotations/refresh/${id}`);

      // pega o objeto atualizado de forma segura (aceita response.data ou response.data.note)
      const updatedNote = response.data && response.data._id ? response.data : (response.data?.note || response.data);

      // normaliza ids como string para evitar mismatch ObjectId x string
      setAllNotes(prevNotes => {
        const newNotes = prevNotes.map(note =>
          String(note._id) === String(id) ? (updatedNote || note) : note
        );
        return newNotes;
      });

      return Promise.resolve(updatedNote); // sucesso, retorna o note atualizado
    } catch (error) {
      console.error('Error refreshing note:', error);
      return Promise.reject(error); // erro
    }
  }



  // FUNÇÕES PARA MANIPULAR A LIXEIRA--------------------------------------------------------------
  // hook para buscar notas excluídas ao abrir a lixeira
  useEffect(() => {
    if (!trashOpen) return;
    async function getTrashNotes() {
      try {
        // Filtra as notas que estão na lixeira a partir de todas as notas e ordena por data de exclusão
        setTrashNotes(
          allNotes
            .filter(note => note.trash)
            .sort((a, b) => new Date(b.date) - new Date(a.date)) // Ordena por data de exclusão (mais recente primeiro)
        );
      } catch (error) {
        console.error('Error retrieving deleted notes:', error);
        toast.error(t("Error loading notes. Try again later!"));
      }
    }

    getTrashNotes();
    // desabilita aviso de dependências
    // eslint-disable-next-line
  }, [trashOpen, allNotes]);

  // função para confirmar a exclusão de uma anotação da lixeira
  function handleConfirmDelete(id) {
    setConfirmModal({
      isOpen: true,
      title: t("Delete Note"),
      message: t("Are you sure you want to permanently delete this note?"),
      onConfirm: () => handleDeleteNote(id),
      onCancel: () => setConfirmModal({ isOpen: false }),
    });
  }

  // função para excluir uma anotação da lixeira
  async function handleDeleteNote(id) {
    setProcessingNoteId(id); // Define o ID da nota que está sendo processada
    try {
      setConfirmModal({ isOpen: false }); // Fecha o modal de confirmação
      await api.delete(`/annotations/delete/${id}`);
      setAllNotes(prevNotes => prevNotes.filter(note => note._id !== id));
      setError(null); // Limpa o erro se sucesso
      setProcessingNoteId(null); // Limpa o ID da nota em processamento
    } catch (error) {
      setProcessingNoteId(null);
      setConfirmModal({ isOpen: false });
      setError(error); // Salva o erro
      console.error('Error deleting annotation:', error);
      toast.error(t("Error deleting annotation from trash."));
    }
  }

  // função para confirmar a limpeza da lixeira
  function handleConfirmClearTrash(id) {
    setConfirmModal({
      isOpen: true,
      title: t("Clear Trash"),
      message: t("Are you sure you want to permanently clear the trash?"),
      onConfirm: () => handleClearTrash(id),
      onCancel: () => setConfirmModal({ isOpen: false }),
    });
  }

  // função para limpar toda a lixeira
  async function handleClearTrash() {
    try {
      setConfirmModal({ isOpen: false }); // Fecha o modal de confirmação
      setLoadingTrash(true);
      await api.delete('/annotations/clear');
      setAllNotes(prevNotes => prevNotes.filter(note => !note.trash));
      setLoadingTrash(false);
      setError(null); // Limpa o erro se sucesso
    } catch (error) {
      setLoadingTrash(false);
      setError(error); // Salva o erro
      console.error('Error emptying the trash can:', error);
      toast.error(t("Error emptying the trash can."));
      setConfirmModal({ isOpen: false });
    }
  }



  // FUNÇÕES PARA DRAG AND DROP (ARRASTAR E SOLTAR NOTAS) MODO MINI NOTAS--------------------------
  // função para ativar o painel de miniaturas
  function activeDropMiniPanel() {
    setDragActive(true);
  }

  // Drop handler específico para o painel de miniaturas (usa as notas visíveis)
  const handleMiniDrop = async (index, miniNotes) => {
    setDragOn(false)
    if (draggedIndex === null || draggedIndex === index) {
      setDragOn(true)
      setDragLoading(null)
      return;
    }
    const updated = [...miniNotes];
    const [removed] = updated.splice(draggedIndex, 1);
    updated.splice(index, 0, removed);

    const previousNotes = [...allNotes];
    // Mescla com as notas que não estão na lista mini (arquivadas/lixeira/outras)
    const otherNotes = allNotes.filter(note => !updated.some(n => n._id === note._id));
    const newAllNotes = [...updated, ...otherNotes];

    setAllNotes(newAllNotes);
    setDraggedIndex(null);
    try {
      const orderedIds = newAllNotes.map(note => note._id);
      await api.put('/annotations/order', { orderedIds });
      setError(null);
    } catch (error) {
      setError(error);
      console.error('Error saving new order (mini):', error);
      setAllNotes(previousNotes);
      toast.dismiss();
      toast.error(t("Error changing the order. Try again later!"));
    } finally {
      setDragOn(true)
      setDragLoading(null)
    }
  };



  // FUNÇÕES DE FILTRO-----------------------------------------------------------------------------
  function handleFilterChange(newFilter) {
    setFilter(newFilter);
  }

  const filteredNotes = allNotes.filter(note => {
    // Filtro por prioridade
    if (filter === "all" && (note.archived || note.trash)) return false;
    if (filter === "priority" && (!note.priority || note.trash || note.archived)) return false;
    if (filter === "completed" && (note.priority || note.trash || note.archived)) return false;
    if (filter === "arquivo" && (!note.archived || note.trash)) return false;

    // Filtro por busca
    if (searchTerm) {
      const termo = searchTerm.toLowerCase();
      const titulo = note.title?.toLowerCase() || '';
      const conteudo = note.notes?.toLowerCase() || '';
      return titulo.includes(termo) || conteudo.includes(termo);
    }
    return true;
  });



  // PAGINA DO MODULO DE ANOTAÇÕES-----------------------------------------------------------------
  return (
    <div className={`${styles.ModuloBlocoNotas} ${isApp ? styles.ModuloBlocoNotasApp : styles.ModuloBlocoNotasWeb}`}>

      {/* MODAL PARA AGUARDAR CARREGAMENTO DAS NOTAS */}
      <div>
        {loading && (
          <div className={styles.modalLoading}>
            <ComponentLoad />
          </div>
        )}
      </div>

      {/* MODAL DE BOAS-VINDAS - PRIMEIRO ACESSO */}
      {showWelcome && (
        <WelcomePanel
          onCancel={() => {
            localStorage.setItem('firstAccess', false);
            setShowWelcome(false);
          }}
        />
      )}

      {/* PAINEL DE NOVIDADES */}
      {newsOpen && (
        <NewsPanel
          onCancel={() => {
            localStorage.setItem('news', false);
            setNewsOpen(false);
          }}
        />
      )}

      {/* MODAL DE PLANO EXPIRADO */}
      {showExpiredPlan && (
        <ExpiredPlanPanel
          onCancel={() => {
            setShowExpiredPlan(false);
          }}
        />
      )}

      {/* FORM PARA INCLUIR NOTAS */}
      <div>
        {NewNoteOpen && (
          <NewNote
            isOpen={NewNoteOpen}
            onConfirm={editingNote ? handleSaveFullEdit : handleSubmit}
            onCancel={() => { setNewNoteOpen(false); setEditingNote(null); }}
            noteToEdit={editingNote}
          />
        )}
      </div>

      {/* MODAL DE VISUALIZAÇÃO DE NOTA */}
      {visualNoteOpen && visualNoteData && (
        <VisualNote
          data={visualNoteData}
          onClose={() => { setVisualNoteOpen(false); setVisualNoteData(null); }}
          onSaveEdit={handleSaveEdit}
          onTrash={handleTrash}
          onArchive={handleArchive}
          onTogglePriority={handleTogglePriority}
          onRefresh={handleRefresh}
          dragActive={activeDropMiniPanel}
          // fontSize={fontSize}
          visualNotes={isApp ? "notaUnica" : "notaUnicaWeb"}
          filter={filter}
          onEditing={isEditingChange}
          onEditDoubleclick={openEditNote}
        />
      )}

      {/* LISTA DE NOTAS */}
      <main>
        {filteredNotes.length === 0 ? (
          <div className={styles.emptyPremium}>
            <div className={styles.premiumIconContainer}>
              <div className={styles.glowEffect}></div>
              <svg className={styles.premiumSvg} viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
                {/* Back card (glassmorphism look) */}
                <g className={styles.floatingGroupBack}>
                  <rect x="70" y="30" width="80" height="110" rx="16" fill="url(#backGradient)" fillOpacity="0.5" transform="rotate(15 110 85)" className={styles.cardBack} />
                </g>

                {/* Front card */}
                <g className={styles.floatingGroup}>
                  <rect x="50" y="40" width="90" height="120" rx="16" fill="url(#docGradient)" className={styles.docBg} stroke="url(#borderGradient)" strokeWidth="1.5" />

                  <rect x="68" y="65" width="54" height="6" rx="3" fill="white" fillOpacity="0.9" className={styles.line1} />
                  <rect x="68" y="85" width="40" height="6" rx="3" fill="white" fillOpacity="0.7" className={styles.line2} />
                  <rect x="68" y="105" width="30" height="6" rx="3" fill="white" fillOpacity="0.5" className={styles.line3} />

                  {/* Floating badge or checkmark */}
                  <circle cx="140" cy="140" r="18" fill="url(#badgeGradient)" className={styles.badge} />
                  <path d="M133 140L138 145L147 135" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className={styles.checkIcon} />
                </g>

                {/* Sparkles and particles */}
                <path d="M35 60 L40 50 L45 60 L55 65 L45 70 L40 80 L35 70 L25 65 Z" fill="url(#sparkleGradient)" className={styles.sparkle1} />
                <path d="M160 55 L163 48 L166 55 L173 58 L166 61 L163 68 L160 61 L153 58 Z" fill="url(#sparkleGradient)" className={styles.sparkle2} />
                <circle cx="45" cy="130" r="4" fill="url(#sparkleGradient)" className={styles.sparkle3} />
                <circle cx="165" cy="110" r="3" fill="url(#sparkleGradient)" className={styles.sparkle4} />
                <circle cx="85" cy="20" r="5" fill="url(#sparkleGradient)" className={styles.sparkle5} />

                <defs>
                  <linearGradient id="docGradient" x1="50" y1="40" x2="140" y2="160" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#3A8DFF" />
                    <stop offset="1" stopColor="#8A2BE2" />
                  </linearGradient>

                  <linearGradient id="backGradient" x1="70" y1="30" x2="150" y2="140" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FF4081" />
                    <stop offset="1" stopColor="#FFA000" />
                  </linearGradient>

                  <linearGradient id="borderGradient" x1="50" y1="40" x2="140" y2="160" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#ffffff" stopOpacity="0.6" />
                    <stop offset="1" stopColor="#ffffff" stopOpacity="0.1" />
                  </linearGradient>

                  <linearGradient id="badgeGradient" x1="122" y1="122" x2="158" y2="158" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#00E676" />
                    <stop offset="1" stopColor="#1DE9B6" />
                  </linearGradient>

                  <linearGradient id="sparkleGradient" x1="0" y1="0" x2="10" y2="10" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FFD700" />
                    <stop offset="1" stopColor="#FF8C00" />
                  </linearGradient>
                </defs>
              </svg>
            </div>
            <p className={styles.emptyTextPremium}>
              {t("You don't have any notes.")}
            </p>
          </div>
        ) : (
          <ul className={styles[visualNotes]}>
            {filteredNotes.map((data) => (
              <li
                key={data._id}
              >
                <Notes
                  data={data}
                  onSaveEdit={handleSaveEdit}
                  onTrash={handleTrash}
                  onArchive={handleArchive}
                  onTogglePriority={handleTogglePriority}
                  onRefresh={handleRefresh}
                  dragActive={activeDropMiniPanel} // <-- passa a função para ativar o painel de miniaturas
                  fontSize={fontSize} // <-- passa o fontSize aqui
                  //fontType={fontType} // <-- passa o fontType aqui
                  visualNotes={isApp ? visualNotes : visualNotes + "Web"} // <-- passa o visualNotes aqui
                  filter={filter}
                  onEditing={isEditingChange}
                  onEditDoubleclick={openEditNote}
                  onDoubleclickNote={openVisualNote}
                />
              </li>
            ))}
          </ul>
        )}
      </main>

      {/* PAINEL PARA MOVER AS NOTAS EM MINIATURA */}
      {dragActive && (
        <div className={styles.miniatureModal}>
          <main className={styles.miniatureContainer}>
            <header>
              <label onClick={() => setDragActive(false)}>&times;</label>
            </header>
            {/* animação da mão arrastando a nota */}
            <div className={styles.dragHandContainer}>
              <TbHandMove className={styles.dragHandIcon} />
              <label> {t("Drag the notes to organize them.")}</label>
            </div>
            <div className={styles.miniaturePanel}>
              {(() => {
                // usa apenas as notas arrastáveis visíveis no painel
                const miniNotes = allNotes.filter(n => !n.archived && !n.trash);
                return miniNotes.map((note, idx) => (
                  <div
                    key={note._id}
                    className={`${styles.miniatureNote} ${dragOverIndex === idx ? styles.dropTarget : ""} ${draggedIndex === idx ? styles.dragging : ""}`}
                    draggable={dragOn}
                    onDragStart={(e) => {
                      setDragLoading(note._id);
                      setDraggedIndex(idx);
                      setDragActive(true);
                    }}
                    onDragOver={(e) => {
                      e.preventDefault();
                      setDragOverIndex(idx);
                    }}
                    onDragLeave={() => setDragOverIndex(null)}
                    onDrop={async (e) => {
                      e.preventDefault();
                      await handleMiniDrop(idx, miniNotes);
                      setDragOverIndex(null);
                    }}
                    onDragEnd={() => {
                      setDraggedIndex(null);
                    }}
                  >
                    <div className={`${styles[note.background]} ${styles.miniatureNoteContent} ${styles[note.priority ? "miniPriority" : ""]}`}>
                      <label>
                        {note.title && note.title.length > 8 ? `${note.title.slice(0, 8)}...` : note.title}
                      </label>
                      {dragLoading === note._id ? (
                        <ClipLoader size={20} color={"#48a04a"} loading={true} />
                      ) : (<label>{idx + 1}</label>)}
                    </div>
                  </div>
                ));
              })()}
            </div>
          </main>
        </div>
      )}

      {/* MENU INFERIOR DE NOTAS */}
      {/* {!isKeyboardVisible && ( */}
      <div style={isApp && !isKeyboardVisible ? { bottom: "70px" } : {}} className={styles.navBar}>
        <Nav
          openForm={setNewNoteOpen}
          openTrash={setTrashOpen}
          onFilterChange={handleFilterChange}
          onFontSizeChange={handleFontSizeChange}
          // onFontTypeChange={handleFontTypeChange}
          onVisualNotesChange={handleVisualNotesChange}
          dragActive={activeDropMiniPanel}
        />
      </div>
      {/* )} */}


      {/* LIXEIRA */}
      {trashOpen && (
        <Trash
          deletedNotes={trashNotes}
          onCancel={setTrashOpen}
          onDelete={handleConfirmDelete}
          onRestore={handleTrash}
          clearTrash={handleConfirmClearTrash}
          loading={loadingTrash}
          processingNoteId={processingNoteId}
        />
      )}

      {/* MODAL DE CONFIRMAÇÃO */}
      {confirmModal.isOpen && (
        <ConfirmModal
          isOpen={confirmModal.isOpen}
          onConfirm={confirmModal.onConfirm}
          onCancel={confirmModal.onCancel}
          title={confirmModal.title}
          message={confirmModal.message}
        />
      )}

      {/* MODAL DE ALERTA */}
      {alertModal.isOpen && (
        <AlertModal
          onConfirm={alertModal.onConfirm}
          title={alertModal.title}
          message={alertModal.message}
        />
      )}

      {/* mensagem de sucesso ao realizar ações */}
      {showSuccess && (
        <InfoAnimation
          message={showSuccessMsg}
          duration={showSuccessDuration}
          onClose={() => setShowSuccess(false)}
        />
      )}

      {/* mensagem de erro ao realizar ações */}
      {showErro && (
        <InfoAnimationErro
          message={showErroMsg}
          duration={showErroDuration}
          onClose={() => setShowErro(false)}
        />
      )}

      {/* TOAST CONTAINER - ALERTAS RÁPIDOS AO USUÁRIO */}
      <ToastContainer
        position="top-right"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme={document.body.classList.contains("theme-dark") ? "dark" : "light"}
      />

    </div>
  );
  // FIM DA PAGINA DO MODULO DE ANOTAÇÕES------------------------------------
}


export default BlocoNotas;